var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{on:{"click":_vm.clearState}},[_vm._v("Clear state")])
}
var staticRenderFns = []

export { render, staticRenderFns }